import {
  PaymentMethod,
  PaymentMethodState,
  PaymentMethodStripeSepa,
  PaymentMethodStripeBacs,
  PaymentMethodStripeMandateStatusEnumType,
  Address,
  Maybe,
  PaymentMethodsCustomerBankAccountSepaType,
  CustomerBankAccountMandateStateEnumType,
  PaymentMethodPurposeEnumType,
  B2BPaymentMethod,
  CorePaymentMethod,
} from "@oysterhr/schema"

import { PaymentMethodEnumType } from "~/app/utils/constants"

export const isUnverifiable = (paymentMethod: CorePaymentMethod) =>
  paymentMethod.__typename === PaymentMethodEnumType.STRIPE_ACH &&
  paymentMethod.verificationAttemptsCount >= 3

export const isAuthorizable = (paymentMethod: PaymentMethod) => {
  if (paymentMethod.__typename === PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA)
    return paymentMethod.state === PaymentMethodState.Initialized
  else if (paymentMethod.__typename !== PaymentMethodEnumType.STRIPE_PAD)
    return paymentMethod.state === PaymentMethodState.Verified
  return false
}
export const isAchAndVerifiable = (paymentMethod: PaymentMethod) =>
  paymentMethod.state === PaymentMethodState.InVerification &&
  paymentMethod.__typename === PaymentMethodEnumType.STRIPE_ACH &&
  paymentMethod.verificationAttemptsCount !== 3

export const isReady = (paymentMethod: PaymentMethod) =>
  paymentMethod.state === PaymentMethodState.AuthorizedForDirectDebit

export const hasCreditorId = (paymentMethod: CorePaymentMethod | B2BPaymentMethod) => {
  if (!isReady(paymentMethod)) return false

  return (
    paymentMethod.__typename === PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_ACH ||
    paymentMethod.__typename === PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA ||
    paymentMethod.__typename === PaymentMethodEnumType.STRIPE_ACH ||
    (paymentMethod.__typename === PaymentMethodEnumType.STRIPE_SEPA &&
      paymentMethod.purpose === PaymentMethodPurposeEnumType.Passing)
  )
}

export const isFtePaymentMethod = (
  paymentMethod: PaymentMethod,
): paymentMethod is B2BPaymentMethod => {
  return (
    paymentMethod.__typename === PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA ||
    paymentMethod.__typename === PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_ACH
  )
}

export const isSepaOrBacsAccount = (
  account: PaymentMethod,
): account is PaymentMethodStripeSepa | PaymentMethodStripeBacs => {
  return (
    account.__typename === "PaymentMethodStripeSepa" ||
    account.__typename === "PaymentMethodStripeBacs"
  )
}

export const isDeactivated = (paymentMethod: CorePaymentMethod) =>
  paymentMethod?.mandate?.status === PaymentMethodStripeMandateStatusEnumType.Inactive

export const showDirectDebitMandate = (
  paymentMethod: PaymentMethod,
): paymentMethod is PaymentMethodStripeSepa | PaymentMethodStripeBacs =>
  isSepaOrBacsAccount(paymentMethod) && isReady(paymentMethod) && !!paymentMethod.mandateUrl

export const formatAddressToSingleLine = (
  address?: Maybe<
    Pick<
      Address,
      "addressLine1" | "addressLine2" | "postalCode" | "city" | "countryCode" | "region"
    >
  >,
) => {
  if (!address) return "-"
  return [
    address.addressLine1,
    address.addressLine2,
    address.city,
    address.region,
    address.countryCode,
    address.postalCode,
  ]
    .filter(Boolean)
    .join(", ")
}

export const HOW_TO_SET_UP_DIRECT_DEBIT_LINK =
  "https://support.oysterhr.com/hc/en-us/articles/4671494999569-How-to-set-up-Direct-debit"

export const SUPPORT_REQUESTS_URL = "https://support.oysterhr.com/hc/en-us/requests/new"

export const getActionAlert = (paymentMethod: PaymentMethodsCustomerBankAccountSepaType) => {
  if (paymentMethod.state !== PaymentMethodState.AuthorizedForDirectDebit) {
    return {
      variation: "warning",
      content: "FTE payment method not yet authorized.",
      actionText: "Authorize payment method",
    }
  }

  switch (paymentMethod.mandate?.state) {
    case CustomerBankAccountMandateStateEnumType.Initialized:
      return {
        variation: "warning",
        content: "Your Direct Debit mandate is ready for you to sign.",
        actionText: "Sign mandate",
      }
  }
}
